<template>
    <FinalContainer
          title="The perfect outfit awaits"
          subtext="You're all set! You can always use the filters to show outfits for specific seasons or price."
    />
</template>

<script>
    import Mixins from "../../../mixins/mixins";
    import FinalContainer from "./final-container.vue";

    export default {
        mixins: [Mixins],
        components: {
            FinalContainer
        }
    };
</script>
